import React, { useState } from 'react';
import cls from './ProcessModal.module.scss';
import Modal from 'components/Modal'; 
import { Bank, Document, GraduationCap, User } from 'assets/icons';
import {useTranslation} from "react-i18next";



export default function ProcessModal({ open, onClose, stage }) {
  const [expandedStep, setExpandedStep] = useState(1);
  const {t} = useTranslation();

  const toggleStep = (step) => {
    setExpandedStep(expandedStep === step ? null : step);
  };

  if (!open) return null;

    const LeftCards = [
        {
            title: 'Mexanizm',
            text: stage.mechanism.name,
            icon: <GraduationCap width='32' height='32'/>
        },
        {
            title: 'Bo‘lim',
            text: stage.department.name,
            icon: <Bank width='32' height='32'/>
        },
        {
            title: 'Klassifikator',
            text: stage.classifier.name,
            icon: <Document width='32' height='32'/>
        },
        {
            title: 'Bajaruvchi',
            text: stage.position.name,
            icon: <User width='32' height='32'/>
        },
        {
            title: 'Raqamlashgan',
            text: t(`enum_type_${stage.digitization_status}`),
            icon: <Document width='32' height='32'/>
        },
    ]


  return (
    <Modal open={open} onCancel={onClose} footer={null} width={1200} className={cls.modal}>
        <div className={cls.header}>
          <h2>
              {stage?.name}
          </h2>
        </div>

        <div className={cls.content}>
          <div className={cls.grid}>

            <div className={cls.left}>
              {stage?.step_responses.map((step) => (
                <div
                  key={step?.id}
                  className={`${cls.stepCard} ${expandedStep === step?.id ? cls.expanded : ''}`}
                  onClick={() => toggleStep(step?.id)}
                >
                  <div className={cls.stepHeader}>
                    <span className={cls.arrow}>
                      {expandedStep === step?.id ? '▼' : '►'}
                    </span>
                    <span className={cls.stepTitle}>{step.order_number}-qadam</span>
                  </div>

                  {expandedStep === step?.id && (
                    <div className={cls.stepBody}>
                      {step?.name && (
                        <div className={cls.stepSubtitle}>
                          <div className={cls.label}>Qadam nomi:</div>
                          <div>{step?.name}</div>
                        </div>
                      )}
                      {step?.description && (
                        <div className={cls.stepNote}>
                          <div className={cls.label}>Izoh</div>
                          <div>{step?.description}</div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className={cls.right}>
              {LeftCards.map((card) => (
                <div key={card.title} className={cls.infoCard}>
                  <div className={cls.icon}>{card.icon}</div>
                  <div className={cls.cardContent}>
                    <div className={cls.cardTitle}>{card.title}</div>
                    <div className={cls.cardText}>{card.text}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
    </Modal>
  ); 
}